function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "165rx09h5b",
  d: "M11.879 28c7.919-6.374 11.879-11.748 11.879-16.121C23.758 5.319 18.439 0 11.878 0 5.319 0 0 5.318 0 11.879 0 16.252 3.96 21.626 11.879 28z"
}), /*#__PURE__*/React.createElement("path", {
  id: "prfon3652c",
  d: "M15 6.635l-5.625-4.37c-.25-.187-.563-.187-.75 0L3 6.635c-.188.125-.25.313-.25.5v6.867c0 1.061.812 1.873 1.875 1.873h8.75c1.063 0 1.875-.812 1.875-1.873V7.135c0-.187-.063-.375-.25-.5zm-4.75 7.991h-2.5V9.632h2.5v4.994zm3.75-.624c0 .375-.25.624-.625.624H11.5V9.008c0-.375-.25-.624-.625-.624h-3.75c-.375 0-.625.25-.625.624v5.618H4.625c-.375 0-.625-.25-.625-.624V7.447l5-3.87 5 3.87v6.555z"
}), /*#__PURE__*/React.createElement("filter", {
  id: "c49ht9hb7a",
  width: "188.4%",
  height: "175%",
  x: "-44.2%",
  y: "-26.8%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 3,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 3
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  values: "0 0 0 0 0.996078431 0 0 0 0 0.596078431 0 0 0 0 0 0 0 0 0.5 0"
})));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-870.000000, -598.000000) translate(876.000000, 601.000000)"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#c49ht9hb7a)",
  xlinkHref: "#165rx09h5b"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#FE9800",
  xlinkHref: "#165rx09h5b"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-870.000000, -598.000000) translate(876.000000, 601.000000) translate(3.000000, 2.000000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "m8loot8oud",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#prfon3652c"
})), /*#__PURE__*/React.createElement("g", {
  fill: "#FFF",
  mask: "url(#m8loot8oud)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0H18.18V18.18H0z"
}))))));
function SvgHomePin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 40,
    viewBox: "0 0 36 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomePin);
export default __webpack_public_path__ + "static/media/home-pin.83e43faba5a395a5ad20f6bd4920d983.svg";
export { ForwardRef as ReactComponent };